import { AxiosInstance } from "axios";

import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";

export class CommonRepository {
	private getAxiosInstance(): AxiosInstance {
		return axiosInstance;
	}
	async getLookupTables() {
		try {
			const resp = await this.getAxiosInstance().get("/Common/lookup-tables");
			return {
				error: false,
				data: resp.data,
			};
		} catch (e) {
			return {
				error: true,
				message: getError(e),
			};
		}
	}

	async getVendors() {
		const resp = await this.getAxiosInstance().get("/common/vendors");
		return {
			error: false,
			data: resp.data,
		};
	}
	async getParts(params: any) {
		const resp = await this.getAxiosInstance().get("/common/parts", {
			params,
		});
		return {
			ok: true,
			data: resp.data,
		};
	}

	async getSpecialParts(params: any) {
		const resp = await this.getAxiosInstance().get("/common/special-parts", {
			params,
		});
		return {
			ok: true,
			data: resp.data,
		};
	}

	async updatePartState(partId: number) {
		const resp = await this.getAxiosInstance().patchForm(
			`/part/${partId}/in-service`,
		);
		return {
			ok: true,
			data: resp.data,
		};
	}
}

export const commonRepository = new CommonRepository();
